/**
 * Discriminates the source of a customer fee row in the unified fees list. Set in code based on which table the row comes from; not persisted.
 */
export enum FeeTypeModel {
	/**
	 * A customer retention rate.
	 */
	RetentionRate = 1,
	/**
	 * A tech enablement fee.
	 */
	TechEnablementFee = 2
}
